import { InfoOutlined } from "@mui/icons-material";
import { Box, Card, Divider, LinearProgress, Tooltip, Typography } from "@mui/material";
import React, { useState, useRef, useEffect } from "react";
import { toCapitalized } from "../../../Utils/Capitalize";
import { trackAnalyticsEvent } from "../../../../utils/clevertap";
import { useSelector } from "react-redux";
const ClubProgressSlider = ({ period=null, progress, spacing, insurance=false }) => {
    const slider_info = progress?.slider_info;
    const title = progress?.title;
    const subtitle = progress?.subtitle;
    const logo = progress?.logo;
    const userData = useSelector(state => state.user?.userData);

    // Track club progress load event
    useEffect(() => {
        if (slider_info) {
            trackAnalyticsEvent('MY_BENEFIT_CLUB_PROGRESS_LOAD', {
                manufacturer_id: userData?.manufacturer_id || '',
                benefit_club: slider_info?.min_club_info?.club_name || slider_info?.max_club_info?.club_name || '',
                benefit_club_period: period?.period || '',
                benefit_club_period_sales: slider_info?.current_value || 0,
                benefit_club_period_sales_uom: slider_info?.uom || ''
            });
        }
    }, [slider_info, userData?.manufacturer_id, period?.period]);

    const handleClubProgressClick = () => {
        trackAnalyticsEvent('MY_BENEFIT_CLUB_PROGRESS_CLICK', {
            manufacturer_id: userData?.manufacturer_id || '',
            benefit_club: slider_info?.min_club_info?.club_name || slider_info?.max_club_info?.club_name || '',
            benefit_club_period: period?.period || '',
            benefit_club_period_sales: slider_info?.current_value || 0,
            benefit_club_period_sales_uom: slider_info?.uom || ''
        });
    };
    
    const percentage = (() => {
        if (!slider_info) return 0;
        if (slider_info.current_value === 0 && slider_info.club_min_value === 0) {
            return 0;
        }
        const totalRange = slider_info.club_max_value;
        const clubMinValue = slider_info.club_min_value;
        if (slider_info.current_value < clubMinValue) {
            const preClubProgress = slider_info.current_value / clubMinValue;
            return Math.pow(preClubProgress, 1.5) * 30;
        }
        const clubProgress = (slider_info.current_value - clubMinValue) / (slider_info.club_max_value - clubMinValue);
        return 30 + (clubProgress * 70);
    })();
    
    return (
        <React.Fragment>
            {period && (
                <Box display="flex" alignItems="center" sx={{ justifyContent: "space-between"}} mb={1}>
                    <Typography variant="h2">{period.display_name}</Typography>
                    <Typography variant="body1" gutterBottom>
                        {period.period}
                    </Typography>
                </Box>
            )}

            <Card sx={{ px: 3, py: 2, boxShadow: '0px 2px 8px 0px #0000001A', borderRadius: 2 }}>
                <Box display="flex" alignItems="center" sx={{ mb: insurance ? 6 : 2 }}>  
                    <Box>
                        <Box
                            component="img"
                            src={logo}
                            alt="Description"
                            sx={{
                                height: '60px',
                                marginRight: 1,
                            }}
                        />
                    </Box>
                    <Box>
                        <Typography variant="h2" sx={{ textTransform: 'capitalize'}}>{toCapitalized(title)}</Typography>
                        <Typography variant="p3">{toCapitalized(subtitle)}</Typography>
                    </Box>
                </Box>  
                {insurance && (
                    <>
                        <Box mt={2} sx={{ position: 'relative' }}>
                            <LinearProgress
                                variant="determinate"
                                value={percentage}
                                sx={{
                                    height: 10,
                                    borderRadius: 5,
                                    '& .MuiLinearProgress-bar': {
                                        backgroundImage: 'linear-gradient(90deg, #995A00 0%, #FFA525 53.5%)',
                                        borderRadius: 5,
                                    },
                                }}
                            />
                            {slider_info?.current_value < slider_info?.club_min_value && (
                                <Box
                                    sx={{
                                        position: 'absolute',
                                        top: '50%',
                                        left: '30%',
                                        transform: 'translate(-50%, -50%)',
                                        zIndex: 2,
                                    }}
                                >
                                    <Box
                                        sx={{
                                            width: 10,
                                            height: 10,
                                            borderRadius: '50%',
                                            backgroundColor: '#995A00',
                                            border: '2px solid #995A00',
                                            boxShadow: '0 0 4px rgba(0,0,0,0.1)',
                                        }}
                                    />
                                    <Box
                                        sx={{
                                            position: 'absolute',
                                            top: 18,
                                            whiteSpace: 'nowrap',
                                            
                                        }}
                                    >
                                        <Typography variant="labelM" sx={{ textTransform: 'capitalize'}}>
                                            {toCapitalized(slider_info?.min_club_info?.club_name)}
                                        </Typography>
                                        <Typography variant="p3" sx={{textTransform: 'capitalize'}}>
                                            {toCapitalized(slider_info?.min_club_info?.range)}
                                        </Typography>
                                    </Box>
                                </Box>
                            )}
                            
                            <Box
                                sx={{
                                position: 'absolute',
                                top: '50%',
                                left: `${percentage}%`,
                                transform: (() => {
                                    if (slider_info?.current_value < slider_info?.club_min_value) {
                                        return slider_info?.current_value === 0
                                            ? 'translate(-50%, -50%)'
                                            : slider_info?.current_value === slider_info?.club_max_value
                                            ? 'translate(-100%, -50%)'
                                            : 'translate(-50%, -50%)';
                                    }
                                    return slider_info?.current_value === slider_info?.club_min_value
                                        ? 'translate(-50%, -50%)'
                                        : slider_info?.current_value === slider_info?.club_max_value
                                        ? 'translate(-100%, -50%)'
                                        : 'translate(-50%, -50%)';
                                })(),
                                zIndex: 1,
                                }}
                            >
                                
                                <Tooltip 
                                    title={`${slider_info?.current_value} ${slider_info?.uom}*`} 
                                    arrow 
                                    placement="top"
                                    open={true}
                                    PopperProps={{
                                        modifiers: [
                                            {
                                                name: 'zIndex',
                                                enabled: true,
                                                phase: 'write',
                                                fn({ state }) {
                                                    state.styles.popper.zIndex = 1000;
                                                },
                                            },
                                        ],
                                    }}
                                    componentsProps={{
                                    tooltip: {
                                        sx: {
                                            bgcolor: '#995A00',
                                            color: 'common.white',
                                            fontSize: '0.75rem',
                                            px: 1,
                                            py: 0.5,
                                            marginBottom: '8px !important',
                                        },
                                    },
                                        arrow: {
                                            sx: {
                                                color: '#995A00',
                                                
                                            },
                                        },
                                    }}
                                >
                                <Box
                                    sx={{
                                        width: 16,
                                        height: 16,
                                        borderRadius: '50%',
                                        backgroundColor: '#fff',
                                        border: '2px solid #FFA525',
                                        boxShadow: '0 0 4px rgba(0,0,0,0.1)',
                                        cursor: 'pointer',
                                    }}
                                    onClick={handleClubProgressClick}
                                />
                                </Tooltip>
                            </Box>
                        </Box>
                    
                        <Box display="flex" justifyContent="space-between" mt={1}>
                            <Box>
                                <Typography variant="labelM">
                                    {slider_info?.current_value >= slider_info?.club_min_value 
                                        ? slider_info?.min_club_info?.club_name 
                                        : `Current Sales`}
                                </Typography>
                                <Typography variant="p3" >
                                    {slider_info?.current_value >= slider_info?.club_min_value 
                                        ? slider_info?.min_club_info?.range
                                        : ``}
                                </Typography>
                            </Box>
                            
                            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems : 'end'}}>
                                <Typography variant="labelM">
                                    {toCapitalized(slider_info?.max_club_info?.club_name)} 
                                </Typography>
                                <Typography variant="p3">
                                    {toCapitalized(slider_info?.max_club_info?.range)}
                                </Typography>
                            </Box>
                        </Box>
                    </>
                )}
                {!insurance && (
                    <Box sx={{ mb: 2 }}>
                        {slider_info?.max_club_info?.range && (
                            <Typography variant="overline" sx={{ mb: .3 }}>
                                Next Club
                            </Typography>
                        )}
                        <Box sx={{ display: 'flex', flexDirection: 'row', alignItems : 'align', justifyContent: 'space-between' }}>
                            <Typography variant="labelD">
                                {slider_info?.max_club_info?.club_name}
                                {slider_info?.max_club_info?.range && ':'}
                            </Typography>
                            <Typography variant="body1" sx={{ color: '#333' }}>
                                {slider_info?.max_club_info?.range}
                            </Typography>
                        </Box>
                    </Box>
                )}
                {slider_info?.next_club_text && (
                    <>
                        <Divider sx={{ my: 1 , mt: (slider_info?.current_value < slider_info?.club_min_value && !slider_info?.max_club_info && insurance) ? 4 : 1  }} />
                        <Box display="flex" justifyContent="space-between" alignItems="center">
                            <Typography variant="labelM" sx={{ display: 'flex', alignItems: 'center' }}>
                                <InfoOutlined sx={{ fontSize: '16px', mr: 0.5 }} />
                                {slider_info?.next_club_text?.display_name}
                            </Typography>   
                            <Typography variant="p3" sx={{ color: '#333' }}>
                                {slider_info?.next_club_text?.value}
                            </Typography>
                        </Box>
                    </>
                )}
                {slider_info?.monthly_sale && (
                    <Box sx={{ pt: 2 }}>
                        <Typography variant="labelD" >Monthly sales</Typography>
                        <Box display="flex" justifyContent="space-between" sx={{ my:2 }}>
                            {slider_info?.monthly_sale?.map((item, index) => (
                                <Box
                                    key={item.display_name}
                                    sx={{
                                        borderRight:
                                        index !== slider_info.monthly_sale.length - 1
                                            ? '1px solid #D9D9D9'
                                            : 'none',
                                        px: 2,
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        width: '50%',
                                        textAlign: 'center',
                                    }}
                                >
                                    <Typography variant="labelD">
                                        {item.display_name}
                                    </Typography>
                                    <Typography variant="p3" sx={{ color: '#666666', }}>
                                        {item.value ? `${item.value} ${slider_info?.uom}` : '-'}
                                    </Typography>
                                </Box>
                            ))}
                        </Box>
                    </Box>
                )}
                {slider_info?.note && insurance && (
                    <Typography variant="p3" sx={{ color: '#666666', mt: 2 }}>
                        {slider_info?.note}
                    </Typography>
                )}
                
            </Card>
        </React.Fragment>
    );
};
export default ClubProgressSlider;